"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7348],{

/***/ 33498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SA": function() { return /* binding */ Board_bs_cliff; },
  "rj": function() { return /* binding */ Board_bs_edward; },
  "oe": function() { return /* binding */ Board_bs_roger; },
  "Zo": function() { return /* binding */ Board_bs_ruth; },
  "R4": function() { return /* binding */ Board_bs_shaun; },
  "JQ": function() { return /* binding */ Board_bs_steve; },
  "QG": function() { return /* binding */ Board_bs_susan; }
});

// UNUSED EXPORTS: adrian, claire, philip

;// CONCATENATED MODULE: ./src/config/BoardConf.ts
var steve = {
    imgUrl: "/images/Board/steve.jpg",
    altTag: "Steve Bon\xe9tt",
    name: "STEVE BON\xc9TT",
    uri: "steve-bon\xe9tt",
    position: "Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/steve-bonett-01489015/",
    description: "Steve is an Executive Director at Precision Group and is actively involved in all aspects of its business. Steve is a professional company director and corporate lawyer with over 25 years experience across the areas of commercial, legal, corporate governance, M&A and finance. He has practised as a partner of Finlaysons Lawyers and at Allen Allen & Hemsley where he led numerous national and international transactions and is a consultant to leading national law firm Thomson Geer.\n\nSteve is the Chairman of national contracting group, Exact Contracting, which operates extensively in the mining, civil and agricultural sectors.\n\nHe has been a Director of Terramin Australia Limited, an ASX listed company and has guided that company from its ASX listing through its growth and portfolio development in Australia and overseas.\n\nSteve also has served on boards of not-for-profit organisations, including The Queen Elizabeth Hospital Research Foundation.\n\nSteve holds degrees in Commerce (Hons) and Law (Hons) from the University of Adelaide and is a Fellow of the Australian Institute of Company Directors.\n"
};
var shaun = {
    imgUrl: "/images/Board/shaun.png",
    altTag: "Shaun Bon\xe9tt",
    name: "SHAUN BON\xc9TT",
    uri: "shaun-bon\xe9tt",
    position: "Co-Founder & Executive Chairman",
    linkedIn: "https://www.linkedin.com/in/shaunbonett/",
    description: "Shaun Bon\xe9tt founded Precision Group in 1994 and serves as its CEO and Managing Director, being principally responsible for the strategic direction of Precision, as well as playing an active role in the purchase, finance and development of all the Group's commercial property.  In addition, Shaun acts as a Director and strategic adviser of various entities Precision has interests in.\n\nShaun holds a Bachelor of Arts (Major in Jurisprudence), Bachelor of Law, and Graduate Diploma in Legal Practice from the University of Adelaide, and is a Barrister and Solicitor of the High Court of Australia.  Shaun is also a Fellow of the Australian Institute of Company Directors, a member of the Young Presidents' Organisation, and of the President's Council of the Art Gallery of NSW.\n\nPhilanthropy is also a key part of Shaun's activities, and he acts as Deputy Chairman of Life Education Australia, is a Director of the Prince's Trust, and is a Director of the Chinese Language and Culture Education Foundation of Australia, and founder of his own charity the Heartfelt Foundation."
};
var claire = {
    imgUrl: "/images/Board/claire.png",
    altTag: "Claire Morris",
    name: "CLAIRE MORRIS",
    uri: "claire-morris",
    position: "Co-Founder & Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/clairemorrisprezzee/",
    description: "Claire is the Co-Founder and a Non-Executive Director of Prezzee. She believes the secret to success is having a great team, company culture combined with a clear vision and strategy for the future. Before Prezzee, Claire founded her first company, Apple&Bee with offices in Sydney and New York and distribution throughout Asia, Europe and North America. She received multiple AGDA brand awards as Art Director at Moon Design before joining Marie Claire Australia as their Art Director for five years.\n\nClaire was part of the 2018 Springboard Founder Cohort, 2019 Heads over Heels Program and won the 2019 Women in Finance Award for Entrepreneur of the Year. In 2020 Claire also received 8th place in the Deloitte Tech Fast 50 Female Leadership award with Prezzee's 509% growth.\n\nClaire is dedicated to helping female founders and being a mentor to women in business to help reach their full potential. She believes that in giving back to others, all boats rise together."
};
var roger = {
    imgUrl: "/images/Board/roger.png",
    altTag: "Roger Hatem",
    name: "ROGER HATEM",
    uri: "roger-hatem",
    position: "Co-Founder & Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/rogerhatem/",
    description: "Roger is the Chief Technology Officer of the Precision Group. Educated in Sydney with a Bachelor of Arts degree in Mathematics and Statistics (Macquarie University), a Master of Science in Operations Research (University of Technology Sydney) and a Microsoft Certified Systems Engineer, Roger is an Information Technology professional with vast experience in management roles across many industries.\n\nRoger is a graduate of the Australian Institute of Company Directors. He is a business leader focused on enablement and transformation who delivers on business strategy and outcomes, through well-defined IT governance and strategy frameworks.\n"
};
var susan = {
    imgUrl: "/images/Board/susan.png",
    altTag: "Susan O'Malley",
    name: "SUSAN O'MALLEY",
    uri: "susan-omalley",
    position: "Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/sue-o-malley-gaicd-50aa496/",
    description: "Sue is a proven leader with a passion for delivering results in collaborative and innovative ways. A technical background in business and marketing and experience in operational and functional leadership in the retail property sector, for Westfield / Scentre Group, in property management, marketing, facilities, sustainability, car park management and customer experience, is combined with a personal approach and commitment to working with and developing teams. Sue's passion is creating organisational value.\n  \n  She is currently Chairperson and Non-Affiliate Director for not-for profit organisation, Life Education Australia, Australia's largest most trusted and credible provider of preventative health education to Australian children, and a member of PeopleStories (‘PS’) Charity Accelerator Board. PS is dedicated to transforming lives through education, one dream at a time. PS is a registered Non-Profit Organization in Hong Kong with charity status as well as registered as Non-Governmental Organisation in Cambodia."
};
var edward = {
    imgUrl: "/images/Board/edward.png",
    altTag: "Edward Piazza",
    name: "EDWARD PIAZZA",
    uri: "edward-piazza",
    position: "Co-Founder & Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/edward-piazza-74bb204/",
    description: "Edward brings to the Board skills and experience in the areas of finance, risk management and strategy.\n\nEdward is currently the Chief Financial Officer of Precision Group, a privately owned investment company focused on the purchase, development, expansion and finance of commercial property as medium to long-term investment holdings, particularly in the retail, commercial office and hospitality sectors. Prior to Precision, he worked for PricewaterhouseCoopers.\n\nEdward is a Chartered Accountant and holds degrees in Commerce (Accounting) and Law and is on the Chartered Accountants Australian New Zealand NSW Corporate Advisory Panel (CAPs). He also holds a graduate Diploma in Legal Practice, and was admitted to the Supreme Court of South Australia."
};
var ruth = {
    imgUrl: "/images/Board/ruth.png",
    altTag: "Ruth Newfield",
    name: "RUTH NEWFIELD",
    uri: "ruth-newfield",
    position: "Company Secretary",
    linkedIn: " https://www.linkedin.com/in/ruthnewfield/",
    description: "Ruth Newfield was appointed Company Secretary in November 2018.  As the Company Secretary Ruth is directly accountable to the Board, through the Chairman, for all matters relating to governance and the proper functioning of the Board.\n\nRuth is also the General Counsel and Company Secretary for Precision Group.  She has over 20 years' experience as a commercial lawyer, both in private practice and as in-house counsel.  Before joining Precision Group, Ruth was Senior Legal Counsel for Westfield and Scentre Group.\n\nRuth holds a Bachelor of Law from the University of Auckland, New Zealand and was admitted as a Barrister and Solicitor of the High Court of New Zealand in 1997.  She is also admitted to the Supreme Courts of New South Wales, Queensland and South Australia.  She is a Fellow of the Governance Institute of Australia and a member of the Association of Corporate Counsel Australia.\n"
};
var cliff = {
    imgUrl: "/images/Board/cliff.png",
    altTag: "Cliff Rosenberg",
    name: "CLIFF ROSENBERG",
    uri: "cliff-rosenberg",
    position: "Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/cliffrosenberg/",
    description: "Cliff has spent more than 20 years working at digital companies leading innovation and change in the industry both as an entrepreneur and senior executive.\n\nCliff was a senior executive at LinkedIn for seven years and until recently serving as the Managing Director of LinkedIn for South East Asia, Australia and New Zealand.\n\nPrior to LinkedIn, Cliff was Managing Director at Yahoo! Australia and New Zealand, and previously the founder and Managing Director of iTouch Australia and New Zealand, one of the largest mobile content and application service providers in Australia. Prior to iTouch Clifford was the head of strategy for Vodafone Australasia.\n\nCliff is also a Non-Executive Director of ASX listed nearmap, TechnologyOne and A2B, and JSE listed Bidcorp. He has a Bachelor of Business Science (Honours) degree and a Master of Science in Management."
};
var philip = {
    imgUrl: "/images/Board/philip.png",
    altTag: "Philip Corne",
    name: "PHILIP CORNE",
    uri: "philip-corne",
    position: "Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/philip-corne-37a3b86/",
    description: "Philip is a Non-Executive Director and business advisor with extensive domestic and international experience leading sophisticated retail businesses and has a deep understanding of the luxury goods sector.\n\nPhilip commenced his professional career with KPMG where he worked from 1978 to 1988. Philip joined Louis Vuitton Australia in 1988 as Head of Finance and in 1998 was appointed Senior Vice President and CFO of Louis Vuitton and the LVMH Fashion Group America's.\n\nIn 2003 Philip assumed the role of Chief Executive Officer of Louis Vuitton Australia and New Zealand a position he held until 2016. In a career spanning almost 30 years with the LVMH Group Philip held senior leadership positions with responsibility for all aspects of business, including finance, strategic planning, property, marketing and client engagement, supply chain, information technology and people.\n\nPhilip holds a Bachelor of Economics from The University of Sydney, is a member of Chartered Accountants Australia and New Zealand and a member of the Australian Institute of Company Directors - GAICD."
};
var adrian = {
    imgUrl: "/images/Board/adrian.png",
    altTag: "Adrian Turner",
    name: "ADRIAN TURNER",
    uri: "adrian-turner",
    position: "Non-Executive Director",
    linkedIn: "https://www.linkedin.com/in/adrian-turner-02a415145/",
    description: "Adrian is an experienced corporate leader with a strong track record building innovative global companies. Adrian is currently Co-Chair of Austcyber, the national program to build a vibrant domestic cybersecurity company that recently merged with Stone and Chalk, Australia's leading innovation hub, with a focus on fintech. The combined organisations have helped 560 start ups and scale ups with 147 alumni companies, who together with residents have raised an aggregate of $520 million since 2014.\n\nHe is CEO of the Minderoo Fire and Flood Resilience Initiative, a collaborative program that uses data modelling and machine learning based prediction to lift resilience so that communities can bounce back stronger from national disasters like the devastating 2019-20 Black Summer fires.\n\nPrior to this, Adrian was the founding CEO of CSIRO's Data61, the digital and data specialist of the national science agency after spending 18 years in Silicon Valley where he was part of the executive team for Evite.com, co-founded Borondi Group, was CEO and co-founder of Mocana corporation a global leader in IOT security, and was appointed Chairman of the Board for Australia's expat network, Advance.org.\n\nAdrian graduated from UTS, completed the Executive Program for Managing Growth Companies at Stanford University, and has authored the book Blue Sky Mining - Building Australia's Next Billion Dollar Industries."
};


;// CONCATENATED MODULE: ./src/bindings/Board.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var Board_bs_steve = steve;
var Board_bs_shaun = shaun;
var Board_bs_claire = claire;
var Board_bs_roger = roger;
var Board_bs_susan = susan;
var Board_bs_edward = edward;
var Board_bs_ruth = ruth;
var Board_bs_cliff = cliff;
var Board_bs_philip = philip;
var Board_bs_adrian = adrian;
 /* steve Not a pure module */ 


/***/ }),

/***/ 47800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p5": function() { return /* binding */ ssr_page_cache; },
/* harmony export */   "yN": function() { return /* binding */ no_cache; }
/* harmony export */ });
/* unused harmony export product_ssr_page_cache */
// Generated by ReScript, PLEASE EDIT WITH CARE
var ssr_page_cache = "public, max-age=600, stale-while-revalidate";
var product_ssr_page_cache = "public, max-age=60, stale-while-revalidate";
var no_cache = "private, no-cache, no-store, max-age=0, must-revalidate";
 /* No side effect */ 


/***/ }),

/***/ 81036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Head */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function SeoMeta(props) {
    var meta = props.meta;
    var router = next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter();
    var match = meta.seoMetaOgType.length;
    var ogType = match !== 0 ? meta.seoMetaOgType : "website";
    var ogImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .mapWithDefault */ .k7(meta.seoMetaOgImageAsset, "", function(b) {
        return b.url;
    });
    var twImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(meta.seoMetaTwImageAsset, function(b) {
        return b.url;
    });
    var twImageUrl = twImageAssetUrl !== undefined ? twImageAssetUrl : meta.seoMetaTwImageAssetUrl;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: meta.seoMetaBasicTitle,
                description: meta.seoMetaBasicDescription,
                canonical: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getCanonicalUrl */ .br.getCanonicalUrl(router.asPath),
                languageAlternates: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SEOUtil.getLanguageAlternates */ .br.getLanguageAlternates(router.asPath),
                openGraph: {
                    title: meta.seoMetaOgTitle,
                    description: meta.seoMetaOgDescription,
                    url: meta.seoMetaOgUrl
                }
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogImageAssetUrl,
                        property: "og:image"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: ogType,
                        property: "og:type"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwTitle,
                        property: "twitter:title"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: meta.seoMetaTwDescription,
                        property: "twitter:description"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: "summary_large_image",
                        property: "twitter:card"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: router.pathname,
                        property: "twitter:url"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("meta", {
                        content: twImageUrl,
                        property: "twitter:image"
                    })
                ]
            })
        ]
    });
}
var Head$1;
var make = SeoMeta;
 /* Util Not a pure module */ 


/***/ }),

/***/ 99967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Img */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
// Generated by ReScript, PLEASE EDIT WITH CARE




function MemberDetail(props) {
    var member = props.member;
    var memberPhoto_src = member.imgUrl;
    var memberPhoto_alt = member.altTag;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S, {
                    src: memberPhoto_src,
                    alt: memberPhoto_alt,
                    width: 650,
                    height: 928,
                    className: "inline-block"
                }),
                className: "lg:w-5/12 md:w-8/12 w-11/12 mx-auto lg:ml-0 h-full xl:w-1/3"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("h1", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(member.name),
                            className: "text-3xl text-prezzee-red font-semibold"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(member.position),
                            className: "text-mid-gray text-sm"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs("a", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("u", {
                                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(" LinkedIn")
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__.FontAwesomeIcon, {
                                        icon: [
                                            "fab",
                                            "linkedin-in"
                                        ]
                                    }),
                                    className: "rounded-full h-8 w-8 text-white justify-center flex items-center bg-prezzee-blue ml-3 my-5"
                                })
                            ],
                            "aria-label": member.name + " at LinkedIn",
                            className: "flex items-center w-32",
                            href: member.linkedIn,
                            target: "_blank"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(member.description),
                            className: "whitespace-pre-line"
                        })
                    ],
                    className: "w-full lg:w-10/12 xl:w-9/12 mx-auto my-3"
                }),
                className: "w-11/12 md:w-8/12 mx-auto lg:w-7/12"
            })
        ],
        className: "lg:flex lg:items-center min-h-0"
    });
}
var Img;
var make = MemberDetail;
 /* Util Not a pure module */ 


/***/ }),

/***/ 73763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "UW": function() { return /* binding */ resolver; }
/* harmony export */ });
/* unused harmony export modifyBlocks */
/* harmony import */ var _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57687);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7667);
/* harmony import */ var _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(607);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94518);
/* harmony import */ var _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47800);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37712);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25400);
/* harmony import */ var _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23328);
// Generated by ReScript, PLEASE EDIT WITH CARE












function modifyBlocks(prim0, prim1, prim2) {
    return ModifyBlocks.modifyBlocks(prim0, prim1, prim2);
}
function resolver(ctx, url, param) {
    if (_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isNone */ .Wi(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"))) {
        ctx.res.setHeader("Cache-Control", _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .ssr_page_cache */ .p5);
    }
    var isPreview = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isSome */ .pC(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"));
    var i = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "lang");
    var language = i !== undefined ? i : null;
    var path = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__/* .get */ .U2(_rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__/* .split */ .Vl("?", ctx.resolvedUrl), 0);
    var queryUrl = url !== undefined ? url : path !== undefined ? path : "";
    return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(res) {
        var content = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .flatMap */ .VS(res, function(p) {
            return p.content;
        });
        var result = _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__/* .fromOption */ .Yo(JSON.stringify(content));
        return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(modifiedResult) {
            return Promise.resolve({
                props: {
                    content: modifiedResult
                }
            });
        }, _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__/* .modifyBlocks */ .IN(result, isPreview, _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language)));
    }, _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getPageContent */ .nW(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language), isPreview, queryUrl));
}
function parse(data) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(data == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(data), _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .parseOrRaise */ .YF);
}
 /* Util Not a pure module */ 


/***/ })

}]);